<template>
    <div class="settings_plate">
      <loading v-if="loading"/>
      <error/>
      <!-- 車牌設定 -->
      <section class="chapternav-top">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <h2 class="section-heading text-uppercase">License</h2>
              <h3 class="section-subheading text-muted">車牌設定</h3>
            </div>
          </div>

            <transition-group  class="row text-center" name="plate-fade" tag="div">
              <div class="col-md-4 setting-plate-box" v-for="(plate, index) in plates" :key="plate.id">
                <div class="setting-plate" v-if="plate.plate">{{ plate.plate }}</div>
                <a class="btn btn-red" data-toggle="modal" v-if="plate.plate" href="#plate-delete-modal" v-on:click="deletePlate(plate.id, index)">
                  <span class="round fa-stack fa-1x"><i class="fas fa-trash fa-stack-1x fa-inverse"></i></span>
                </a>
                <div class="setting-plate-add" v-if="plates.length <= 3 && index + 1 == plates.length">尚未綁定車牌</div>
                <a v-if="plates.length <= 3 && index + 1 == plates.length" class="btn btn-green" data-toggle="modal" href="#plate-create-modal">
                  <span class="round fa-stack fa-1x"><i class="fas fa-plus fa-stack-1x fa-inverse"></i></span>
                </a>
              </div>
            </transition-group>

          </div>
      </section>
      
      <!-- plate-delete-modal -->
      <div class="plate-modal modal fade" id="plate-delete-modal" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="close-modal" data-dismiss="modal">
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <h3 class="">確定刪除</h3>
                    <ul class="list-inline" v-if="delete_plate_index >= 0">
                      <li>車牌：{{ plates[delete_plate_index].plate }}</li>
                    </ul>
                    <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button">
                      取消刪除
                    </button>
                    <button class="btn btn-primary btn-red" data-dismiss="modal" type="button" v-on:click="confirmDeletePlate()">
                      確定刪除
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div><!-- modal-content ends -->
        </div><!-- modal-dialog ends -->
      </div>
      <!-- plate-delete-modal ends -->

      <!-- plate-create-modal -->
      <div class="plate-modal modal fade" id="plate-create-modal" tabindex="-2" role="dialog" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="close-modal" data-dismiss="modal">
              <div class="lr">
                <div class="rl"></div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-lg-8 mx-auto">
                  <div class="modal-body">
                    <!-- Project Details Go Here -->
                    <h3 class="">新增車牌</h3>
                    <p class="item-intro text-muted">請記得輸入『-』</p>
                    <!--<img class="img-fluid d-block mx-auto" src="img/parkit/parkinglot/01-full.jpg" alt="">
                    <p>Use this area to describe your project. Lorem ipsum dolor sit amet, consectetur adipisicing elit. Est blanditiis dolorem culpa incidunt minus dignissimos deserunt repellat aperiam quasi sunt officia expedita beatae cupiditate, maiores repudiandae, nostrum, reiciendis facere nemo!</p>-->
                    <ul class="list-inline">
                      <li>
                        <input class="input-group col-sm-12 form-control" v-model="new_plate" type="text" placeholder="ex. ABC-1234" :class="{'is-invalid': plate_format_error, 'shake': shake_animate}">
                        <transition name="fade">
                          <div class="invalid-feedback" v-if="plate_format_error">
                            {{ plate_error }}
                          </div>
                        </transition>
                      </li>
                    </ul>
                    <button class="btn btn-primary btn-frame" data-dismiss="modal" type="button" v-on:click="cancelNewPlate">
                      取消新增
                    </button>
                    <button class="btn btn-primary btn-green" type="button" v-on:click="postPlate">
                      確定新增
                    </button>
                  </div><!-- modal-body ends -->
                </div><!-- col-lg-8 mx-auto ends -->
              </div><!-- row ends -->
            </div><!-- container ends -->
          </div><!-- modal-content ends -->
        </div><!-- modal-dialog ends -->
      </div>
      <!-- plate-create-modal ends -->
    </div>
</template>

<style>

</style>

<script>
export default {
  name: 'SettingPlate',
  props: {
    msg: String
  },
  data() {
    return {
      plates: [],
      new_plate: "",
      delete_plate_id: -1,
      loading: true,
      plate_format_error: false,
      delete_plate_index: -1,
      plate_error: "車牌格式有誤",
      shake_animate: false
    }
  },
  mounted() {
    var self = this;
    self.getPlate()
  },
  methods: {
    getPlate: function() {
      var self = this
      self.$http.get('https://' + process.env.VUE_APP_API_URL + '/license_plates?access_token=' + self.$cookie.get('access_token'))
        .then((response) => {
          self.plates = response.body
          self.plates.push({id: -10})
          self.loading = false
        })
        .catch((response) => {
          console.log("取得資料失敗")
          self.$router.push({ name: 'member_center' })
        })
        .finally(() => {
        });
    },
    postPlate: function() {
      var self = this
      self.plate_error = "車牌格式有誤"
      if (self.new_plate.indexOf("-") >= 0 && self.new_plate.charAt(0) != '-' && self.new_plate.charAt(-1) != '-' && self.new_plate.length < 10) {
        var verifyPlate = self.new_plate
        verifyPlate = verifyPlate.replace('-', '')
        if (/^\w+$/.test(verifyPlate)) {
          self.loading = true
          self.plate_format_error = false
          self.$http.post('https://' + process.env.VUE_APP_API_URL + '/license_plates?access_token=' + self.$cookie.get('access_token'), {
            plate: self.new_plate.toUpperCase()
          })
          .then((response) => {
            self.getPlate()
            self.loading = false
            self.new_plate = ""
            $("#plate-create-modal").modal("hide")
          })
          .catch((response) => {
            self.loading = false
            self.plate_format_error = true
            if (response.body === 'plate up to limit') {
              self.plate_error = "車牌綁定已達上限"
            } else {
              self.plate_error = "新增時發生錯誤，請稍後再試"
            }
          })
          .finally(() => {
          });
        } else {
          self.plate_format_error = true
          self.shake_animate = true
          setTimeout(function(){ self.shake_animate = false; }, 1000)
        }
      } else {
        self.plate_format_error = true
        self.shake_animate = true
        setTimeout(function(){ self.shake_animate = false; }, 1000)
      }
    },
    deletePlate: function(id, index) {
      var self = this
      self.delete_plate_id = id
      self.delete_plate_index = index
    },
    confirmDeletePlate: function() {
      var self = this
      self.loading = true
      self.$http.delete('https://' + process.env.VUE_APP_API_URL + '/license_plates/' + self.delete_plate_id + "?access_token=" + self.$cookie.get('access_token'))
      .then((response) => {
        self.plates.splice(self.delete_plate_index, 1)
        self.loading = false
      })
      .catch((response) => {
        self.loading = false
        $("#error-modal").modal('show')
      })
      .finally(() => {
      });
    },
    cancelNewPlate: function() {
      var self = this
      self.plate_format_error = false
      self.new_plate = ""
    }
  }
}
</script>